import { FC, useEffect, useState } from "react";
import { getManagement } from "../../../api/transport/staffTransport";
import { PersonCard, PersonList } from "../../../components/PersonCard";
import { StaffDto } from "../../../types/staff";
import { Loader } from "../../../components/Loader";
import { getFormattedDateNumeric, getStaticUrl, setDocumentTitle } from "../../../utils";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { SiteType, TeamContext } from "../../../types/common";

interface ManagementPageProps { }

const ManagementPage: FC<ManagementPageProps> = ({ }) => {
    const [loading, setLoading] = useState(true);
    const [staff, setStaff] = useState<StaffDto[]>([]);
    const config = useConfiguration();

    let pageTitle = 'Менеджмент';

    if (config.site === SiteType.LEGACY_ACADEMY) {
        pageTitle = 'Руководство';
    }


    useEffect(() => {
        setLoading(true);
        getManagement(config?.teamName)
            .then((data) => {
                setStaff(data);
            })
            .finally(() => {
                setLoading(false);
            });
        setDocumentTitle(`${pageTitle} - Официальный сайт ${config.site === SiteType.LEGACY_ACADEMY ? "Академия" : "ФК"} «Родина»`);
    }, [config?.teamName]);

    if (loading) {
        return <Loader />;
    }

    return (
        <div className="max-w-[1000px] mx-auto p-2 pb-6">
            <h1 className="py-4 sm:pb-8 text-2xl sm:text-3xl font-semibold text-center text-slate-950">{pageTitle}</h1>
            <PersonList>
                {staff.map(staffMember => {
                    let birthDate = staffMember.birthDate ? getFormattedDateNumeric(new Date(staffMember.birthDate)) : '';
                    if (config?.teamName === TeamContext.RODINA || config?.teamName === TeamContext.RODINA_2 || config?.teamName === TeamContext.RODINA_3) {
                        birthDate = '';
                    }
                    return (
                        <PersonCard
                            key={staffMember.uuid}
                            name={staffMember.fullName}
                            title={staffMember.title}
                            photo={getStaticUrl(staffMember.photoUrl)}
                            birthDate={birthDate}
                        />
                    )
                })}
            </PersonList>
        </div>
    );
}

export default ManagementPage;